import { Container } from "react-bootstrap";
import Header from "./Header";
import NumSection from "./Num-section";
import SectionThree from "./SectionThree";
import SectionTow from "./SectionTow";
import VideoSection from "./VideoSection";
import Orders from "./Orders";
import Slider from "./Slider";
import SectionFor from "./SectionFor";

function Home(){
    return(
        <>
        <Header />
        <NumSection />
        <SectionTow />
        <SectionThree />
        <VideoSection />
        <section id="section3">
            <Container>
                <div style={{width:'70%', margin:'auto', textAlign:'center', padding: '40px 0'}}>
                <h2 style={{color:" #43121d",
                            marginBottom: "15px",
                            fontSize: "36px",
                            lineHeight: "46px",
                            fontWeight: "700"}}>
                Explore Our Foods
                </h2>
                <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et purus a odio finibus bibendum in sit amet leo. Mauris feugiat erat tellus. Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove.
                </p>
                </div>
            </Container>
        </section>
        <Orders />
        <Slider />
        <SectionFor />
        </>
    )
}
export default Home;